var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mds-tag',{attrs:{"removable":""},on:{"mds-tag-removed":function($event){return _vm.$emit('closeItem', _vm.label)}}},[_c('strong',[_vm._v(_vm._s(_vm.type)+": ")]),_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }